import type {
  ClassificationInput,
  ClassificationResponse,
} from '../../domain/entities/sinarem-report.entity';
import type { GeneralReport } from '../../domain/entities/general-report.entity';
import type { QuestionDistribution } from '../../domain/entities/question-distribution.entity';
import type { QuestionList } from '../../domain/entities/question-list.entity';
import type { AreaComparison } from '../../domain/entities/area-comparison.entity';
import type { ThemeComparison } from '../../domain/entities/theme-comparison.entity';
import type { StudentRanking } from '../../domain/entities/student-ranking.entity';
import type { StudentDetail } from '../../domain/entities/student-detail.entity';
import type { SinaremReportsApiDatasource } from '../datasources/sinarem-reports-api.datasource';

export class SinaremReportsRepositoryImpl {
  private readonly api: SinaremReportsApiDatasource;

  constructor(api: SinaremReportsApiDatasource) {
    this.api = api;
  }

  async getClassification(
    input?: ClassificationInput,
  ): Promise<ClassificationResponse> {
    return this.api.getClassification(input);
  }

  async getGeneralReport(
    editionId: string,
    includeExtra?: boolean,
  ): Promise<GeneralReport> {
    return this.api.getGeneralReport(editionId, includeExtra);
  }

  async getQuestionDistribution(
    editionId: string,
    includeExtra?: boolean,
  ): Promise<QuestionDistribution> {
    return this.api.getQuestionDistribution(editionId, includeExtra);
  }

  async getQuestionList(
    editionId: string,
    includeExtra?: boolean,
  ): Promise<QuestionList> {
    return this.api.getQuestionList(editionId, includeExtra);
  }

  async getAreaComparison(editionId: string): Promise<AreaComparison> {
    return this.api.getAreaComparison(editionId);
  }

  async getThemeComparison(editionId: string): Promise<ThemeComparison> {
    return this.api.getThemeComparison(editionId);
  }

  async getStudentRanking(
    editionId: string,
    page: number,
    pageSize: number,
  ): Promise<StudentRanking> {
    return this.api.getStudentRanking(editionId, page, pageSize);
  }

  async getStudentDetail(
    editionId: string,
    email: string,
  ): Promise<StudentDetail> {
    return this.api.getStudentDetail(editionId, email);
  }
}
